import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { VkMusicCancelSubscriptionMobileProps } from 'reactApp/ui/VkMusic/VkMusicCancelSubscription/mobile/VkMusicCancelSubscriptionMobile/VkMusicCancelSubscriptionMobile';

export const renderVkMusicCancelSubscriptionMobile = (data: VkMusicCancelSubscriptionMobileProps) =>
    openPopupHelper({ popupName: popupNames.VK_MUSIC_CANCEL_SUBS_MODAL_MOBILE, data });

export const closeVkMusicCancelSubscriptionMobile = () => closePopupHelper(popupNames.VK_MUSIC_CANCEL_SUBS_MODAL_MOBILE);
